<template>
    <div id="app">
        <div class="main">
            <Header />
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
            <!-- <Footer /> -->
        </div>
    </div>
</template>
<script>
import { Header,Footer } from '@/components'
    export default {
        components: {
            Header,
            Footer,
        },
        data () {
            return {
                selectedLabelSlots: 'Like',
                reg_from: '', // 渠道参数
                qd_code: '', // 渠道参数
            }
        },
        created() {
            this.reg_from = this.$route.query.reg_from || sessionStorage.getItem('reg_from') || ''
            this.qd_code = this.$route.query.qd_code || sessionStorage.getItem('qd_code') || ''
            sessionStorage.setItem('reg_from', this.reg_from)
            sessionStorage.setItem('qd_code', this.qd_code)
            // 存储渠道参数到session缓存中
        },
        methods: {}

    }
</script>

<style lang="stylus">
    @import "assets/stylus/main.styl"
    #app {
        position relative;
        overflow auto;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }


</style>
